import { render, staticRenderFns } from "./FormControlUploadFile.vue?vue&type=template&id=4222ef6c&"
import script from "./FormControlUploadFile.vue?vue&type=script&lang=js&"
export * from "./FormControlUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports